module.exports = __webpack_public_path__ + "static/img/ticketExampleSmall.ae64755.png";